export const API_BASE_PATH = 'admin-upcoming-filings';

export const UNASSIGNED_AGENT_FIRM_SENTINEL = 'UNASSIGNED';
